import { useState } from "react";
import { useLocation } from "react-router-dom";
import { saveEnquiry } from "../services/enquiryService";

console.log("SaveEnquiry:", saveEnquiry);
export default function EnquiryForm() {
  const location = useLocation();

  const selectedService = location.state?.service || "";

  const [formData, setFormData] = useState({
    // Personal Information
    name: "",
    phone: "",
    emergencyPhone: "",
    email: "",
    city: "",
    pincode: "",
    address: "",

    // Service Information
    service: selectedService,
    startDate: "",
    contactTime: "",

    // Care Information
    careFor: "",
    otherCareFor: "",

    // Additional Information
    additionalInfo: "",

    // Consent
    consent: false,
  });
const [isSubmitting, setIsSubmitting] = useState(false);
const [isSubmitted, setIsSubmitted] = useState(false);
const [referenceId, setReferenceId] = useState("");
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    let inputValue = value;

    // Allow only numbers for phone fields
    if (name === "phone" || name === "emergencyPhone") {
      inputValue = value.replace(/\D/g, "").slice(0, 10);
    }

    // Allow only numbers for pincode
    if (name === "pincode") {
      inputValue = value.replace(/\D/g, "").slice(0, 6);
    }

    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : inputValue,
    }));
  };
const validateForm = () => {
  const newErrors = {};

  // Name
  if (!formData.name.trim()) {
    newErrors.name = "Full name is required.";
  } else if (formData.name.trim().length < 3) {
    newErrors.name = "Name must be at least 3 characters.";
  }

  // Phone
  if (!formData.phone) {
    newErrors.phone = "Mobile number is required.";
  } else if (formData.phone.length !== 10) {
    newErrors.phone = "Mobile number must be exactly 10 digits.";
  }

  // Email
  if (!formData.email.trim()) {
    newErrors.email = "Email is required.";
  } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
    newErrors.email = "Please enter a valid email address.";
  }

  // City
  if (!formData.city.trim()) {
    newErrors.city = "City is required.";
  }

  // Pincode
  if (!formData.pincode) {
    newErrors.pincode = "Pincode is required.";
  } else if (formData.pincode.length !== 6) {
    newErrors.pincode = "Pincode must be exactly 6 digits.";
  }

  // Address
  if (!formData.address.trim()) {
    newErrors.address = "Address is required.";
  }

  // Care For
  if (!formData.careFor) {
    newErrors.careFor = "Please select who needs care.";
  }

  if (
    formData.careFor === "Other" &&
    !formData.otherCareFor.trim()
  ) {
    newErrors.otherCareFor = "Please specify.";
  }
console.log("Validation Errors:", newErrors);
console.log("Current Form Data:", formData);
  console.log(newErrors);

setErrors(newErrors);

  return Object.keys(newErrors).length === 0;
};
const handleSubmit = async (e) => {
  e.preventDefault();
if (!validateForm()) {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
  return;
}
  setIsSubmitting(true);

  const result = await saveEnquiry(formData);

if (result.success) {
  setReferenceId(result.id);
  setIsSubmitted(true);

  console.log("Document ID:", result.id);
} else {
    alert("Something went wrong. Please try again.");
  }

  setIsSubmitting(false);
};
  const [errors, setErrors] = useState({});

if (isSubmitted) {
  return (
    <div className="max-w-3xl mx-auto px-6 py-20">
      <div className="bg-white rounded-3xl shadow-soft border border-sage-100 p-10 text-center">

        <div className="text-6xl mb-6">
          ✅
        </div>

        <h1 className="font-serif text-4xl text-ink mb-4">
          Thank You!
        </h1>

        <p className="text-lg text-ink-muted mb-8">
          Your enquiry has been submitted successfully.
        </p>

        <div className="bg-sage-50 rounded-2xl p-6 mb-8">

          <p className="text-sm text-gray-500">
            Reference ID
          </p>

          <p className="font-semibold break-all">
            {referenceId}
          </p>

          <p className="mt-4 text-gray-600">
            Our care coordinator will contact you within 24 hours.
          </p>

        </div>

        <div className="flex justify-center gap-4">

          <button
            onClick={() => window.location.href = "/"}
            className="px-6 py-3 rounded-full bg-sage-600 text-white"
          >
            Back to Home
          </button>

          <button
            onClick={() => window.location.reload()}
            className="px-6 py-3 rounded-full border border-sage-300"
          >
            Submit Another Enquiry
          </button>

        </div>

      </div>
    </div>
  );
}
  
  return (
    
 <form
  onSubmit={handleSubmit}
  className="max-w-5xl mx-auto px-6 py-16"
>
  <div className="bg-white rounded-3xl shadow-soft border border-sage-100 p-8 md:p-10">

    <div className="mb-10">
      <h1 className="font-serif text-4xl text-ink">
        Service Enquiry
      </h1>

      <p className="mt-3 text-ink-muted">
        Tell us about your requirements and our care coordinator will contact you shortly.
      </p>
    </div>

    {/* PERSONAL INFORMATION */}

    <div className="mb-10">

      <h2 className="font-serif text-2xl text-ink mb-6">
        Personal Information
      </h2>

      <div className="grid md:grid-cols-2 gap-6">

        {/* Name */}

        <div>
         <label className="block mb-2 font-medium">
  Full Name <span className="text-red-500">*</span>
</label>

          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="Enter your full name"
            className="w-full rounded-xl border border-sage-200 px-4 py-3"
          />
          {errors.name && (
  <p className="mt-1 text-sm text-red-600">
    {errors.name}
  </p>
)}
        </div>

        {/* Mobile */}

        <div>
          <label className="block mb-2 font-medium">
            Mobile Number *
          </label>

          <input
            type="tel"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            placeholder="10-digit mobile number"
            className="w-full rounded-xl border border-sage-200 px-4 py-3"
          />
          {errors.phone && (
  <p className="mt-1 text-sm text-red-600">
    {errors.phone}
  </p>
)}
        </div>

        {/* Emergency */}

        <div>
          <label className="block mb-2 font-medium">
            Emergency Contact Number
          </label>

          <input
            type="tel"
            name="emergencyPhone"
            value={formData.emergencyPhone}
            onChange={handleChange}
            placeholder="Optional"
            className="w-full rounded-xl border border-sage-200 px-4 py-3"
          />
        </div>

        {/* Email */}

        <div>
          <label className="block mb-2 font-medium">
            Email Address
          </label>

          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="example@email.com"
            className="w-full rounded-xl border border-sage-200 px-4 py-3"
          />
          {errors.email && (
  <p className="mt-1 text-sm text-red-600">
    {errors.email}
  </p>
)}
        </div>

        {/* City */}

        <div>
          <label className="block mb-2 font-medium">
            City *
          </label>

          <input
            type="text"
            name="city"
            value={formData.city}
            onChange={handleChange}
            placeholder="City"
            className="w-full rounded-xl border border-sage-200 px-4 py-3"
          />
          {errors.city && (
  <p className="mt-1 text-sm text-red-600">
    {errors.city}
  </p>
)}
        </div>

        {/* Pincode */}

        <div>
          <label className="block mb-2 font-medium">
            Pincode *
          </label>

          <input
            type="text"
            name="pincode"
            value={formData.pincode}
            onChange={handleChange}
            placeholder="6-digit pincode"
            className="w-full rounded-xl border border-sage-200 px-4 py-3"
          />
          {errors.pincode && (
  <p className="mt-1 text-sm text-red-600">
    {errors.pincode}
  </p>
)}
        </div>

        {/* Address */}

        <div className="md:col-span-2">
          <label className="block mb-2 font-medium">
            Address *
          </label>

          <textarea
            rows={4}
            name="address"
            value={formData.address}
            onChange={handleChange}
            placeholder="Enter complete address"
            className="w-full rounded-xl border border-sage-200 px-4 py-3"
          />
          {errors.address && (
  <p className="mt-1 text-sm text-red-600">
    {errors.address}
  </p>
)}
        </div>

      </div>

    </div>
    
    {/* SERVICE INFORMATION */}

<div className="mb-10">

  <h2 className="font-serif text-2xl text-ink mb-6">
    Service Information
  </h2>

  <div className="grid md:grid-cols-2 gap-6">

    <div className="md:col-span-2">
      <label className="block mb-2 font-medium">
        Selected Service
      </label>

      <input
        type="text"
        value={selectedService}
        readOnly
        className="w-full rounded-xl border border-sage-200 bg-gray-100 px-4 py-3"
      />
      {errors.careFor && (
  <p className="mt-1 text-sm text-red-600">
    {errors.careFor}
  </p>
)}
{errors.otherCareFor && (
  <p className="mt-1 text-sm text-red-600">
    {errors.otherCareFor}
  </p>
)}
    </div>

    <div>
      <label className="block mb-2 font-medium">
        Preferred Start Date
      </label>

   <input
  type="date"
  name="startDate"
  value={formData.startDate}
  onChange={handleChange}
  min={new Date().toISOString().split("T")[0]}
  className="w-full rounded-xl border border-sage-200 px-4 py-3"
/>
    </div>

    <div>
      <label className="block mb-2 font-medium">
        Preferred Contact Time
      </label>

      <select
        name="contactTime"
        value={formData.contactTime}
        onChange={handleChange}
        className="w-full rounded-xl border border-sage-200 px-4 py-3"
      >
        <option value="">Select</option>
        <option value="Morning">Morning</option>
        <option value="Afternoon">Afternoon</option>
        <option value="Evening">Evening</option>
        <option value="Anytime">Anytime</option>
      </select>
    </div>
    

  </div>
</div>
{/* CARE INFORMATION */}

<div className="mb-10">

  <h2 className="font-serif text-2xl text-ink mb-6">
    Care Information
  </h2>

  <div>

    <label className="block mb-2 font-medium">
      Who is this care for?
    </label>

    <select
      name="careFor"
      value={formData.careFor}
      onChange={handleChange}
      className="w-full rounded-xl border border-sage-200 px-4 py-3"
    >
      <option value="">Select</option>
      <option value="Myself">Myself</option>
      <option value="My Child">My Child</option>
      <option value="My Parent">My Parent</option>
      <option value="My Grandparent">My Grandparent</option>
      <option value="My Spouse">My Spouse</option>
      <option value="Other">Other</option>
    </select>

  </div>

  {formData.careFor === "Other" && (

    <div className="mt-6">

      <label className="block mb-2 font-medium">
        Please Specify
      </label>

      <input
        type="text"
        name="otherCareFor"
        value={formData.otherCareFor}
        onChange={handleChange}
        placeholder="Please specify"
        className="w-full rounded-xl border border-sage-200 px-4 py-3"
      />

    </div>

  )}

</div>

{/* ADDITIONAL INFORMATION */}

<div className="mb-10">

  <h2 className="font-serif text-2xl text-ink mb-6">
    Additional Information
  </h2>

  <label className="block mb-2 font-medium">
    Anything else you'd like us to know?
  </label>

  <textarea
    name="additionalInfo"
    value={formData.additionalInfo}
    onChange={handleChange}
    rows={5}
    maxLength={500}
    placeholder="Please share any special requirements, medical conditions, allergies, preferred caregiver, or any other details..."
    className="w-full rounded-xl border border-sage-200 px-4 py-3"
  />

  <div className="text-right text-sm text-gray-500 mt-2">
    {formData.additionalInfo.length}/500 characters
  </div>

</div>

{/* CONSENT */}

<div className="mb-10">

  <label className="flex items-start gap-3">

    <input
      type="checkbox"
      name="consent"
      checked={formData.consent}
      onChange={handleChange}
      className="mt-1"
    />

    <span className="text-sm text-gray-700">
      I agree that Anara Lifethread may contact me regarding this enquiry.
    </span>

  </label>

</div>

<div className="flex justify-end">

 <button
  type="submit"
  disabled={!formData.consent || isSubmitting}
  className={`px-8 py-3 rounded-full font-medium transition ${
    formData.consent
      ? "bg-sage-600 hover:bg-sage-700 text-white"
      : "bg-gray-300 text-gray-500 cursor-not-allowed"
  }`}
>
  {isSubmitting ? "Submitting..." : "Submit Enquiry →"}
</button>

</div>

</div>
</form>
  );
}